module.exports = __webpack_public_path__ + "media/images/resources-new-folder-c9226057fef3e9e8430fe78b6dc9a42b.svg";